import React, { useContext } from 'react';
import ImportSynchTripResultContext from './context';
import SynchTripResultTable from './resultTable';
import { useValidateData } from './hooks';

const SynchTripResultVerfication = () => {
  const synchTripResult = useValidateData();
  const synchTripContext = useContext(ImportSynchTripResultContext);

  return (
    <>
      <div
        id="verification-synchtripresult-table"
        className="flex flex-column"
        style={{ height: '100%', overflow: 'scroll' }}
      >
        {synchTripResult && <SynchTripResultTable tableData={synchTripResult} />}
      </div>
      <div id="verification-results-wrapper" style={{ width: '70%' }}>
        <span id="verification-results-count" style={{ marginRight: '30px' }}>
          Results Count: {synchTripContext?.synchTripResultImportDTOList?.length}
        </span>
        <span id="verification-results-valid-length" style={{ marginRight: '30px' }}>
          Valid :{' '}
          {
            synchTripContext?.synchTripResultImportDTOList?.filter(
              (x) => !x.isDataInvalid,
            ).length
          }
        </span>
        <span id="verification-results-invalid-length" style={{ marginRight: '30px' }}>
          Invalid :{' '}
          {
            synchTripContext?.synchTripResultImportDTOList?.filter((x) => x.isDataInvalid)
              .length
          }
        </span>
      </div>
    </>
  );
};

export default SynchTripResultVerfication;
